import React from "react";

function LoginIcon(props) {
    const width = props.width || '2.4rem';
    const height = props.height || '2.4rem';
    const offset = props.offset || 0;
    const className = props.className || '';
    return (
        <span className={className}>
            <svg
               xmlns="http://www.w3.org/2000/svg"
               width={width}
               height={height}
               style={{
                   transform: `translate(0, ${offset})`,
                   verticalAlign: 'middle'
               }}
               x="0px"
               y="0px"
               viewBox="0 0 16 16"
            >
                <path d="M 7.5 1 C 5.3292398 1 3.4011149 2.0674501 2.2207031 3.7070312 A 0.50007728 0.50007728 0 0 0 2.1816406 3.7695312 C 1.9115085 4.1564749 1.6981604 4.57148 1.5195312 5 L 2.6015625 5 C 2.7265625 4.755 2.8702031 4.5189688 3.0332031 4.2929688 L 3.03125 4.2929688 C 4.0308382 2.9045499 5.6567602 2 7.5 2 C 10.543833 2 13 4.456167 13 7.5 C 13 10.543833 10.543833 13 7.5 13 C 5.7082346 13 4.1222551 12.14658 3.1171875 10.824219 C 2.9191875 10.563219 2.7514687 10.286 2.6054688 10 L 1.5195312 10 C 1.7185698 10.474849 1.9620461 10.933457 2.2734375 11.357422 A 0.50005 0.50005 0 0 0 2.3144531 11.419922 A 0.50005 0.50005 0 0 0 2.3203125 11.427734 C 2.3208689 11.428466 2.3217089 11.428956 2.3222656 11.429688 C 3.5092934 12.990079 5.3907546 14 7.5 14 C 11.084167 14 14 11.084167 14 7.5 C 14 3.915833 11.084167 1 7.5 1 z M 8 5 L 8 7 L 1 7 L 1 8 L 8 8 L 8 10 L 10.5 7.5 L 8 5 z"/>
            </svg>
        </span>
    );
}

export default LoginIcon;
